import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7 10.5H5.5v-3H7a1.5 1.5 0 1 1 0 3" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm7.5 8.375c0-.483.392-.875.875-.875h.875c.723 0 1.036.202 1.158.31a.5.5 0 0 1 .124.157.75.75 0 0 0 1.446-.399l-.728.182c.728-.182.727-.183.727-.183v-.004l-.002-.005-.003-.012a1.5 1.5 0 0 0-.129-.31 2 2 0 0 0-.438-.547C14.964 6.298 14.277 6 13.25 6h-.875A2.375 2.375 0 0 0 10 8.375c0 .81.55 1.415 1.082 1.771.55.37 1.256.604 1.918.604.338 0 .756.13 1.082.348.343.232.418.44.418.527a.875.875 0 0 1-.875.875h-.875c-.723 0-1.036-.202-1.158-.31a.5.5 0 0 1-.122-.152l-.002-.005a.75.75 0 0 0-1.446.399l.728-.182c-.728.182-.727.183-.727.183v.004l.002.005.003.012.008.028q.01.032.026.074.031.087.095.208c.087.16.225.357.438.547.441.391 1.128.689 2.155.689h.875A2.375 2.375 0 0 0 16 11.625c0-.81-.55-1.415-1.082-1.772-.55-.37-1.256-.603-1.918-.603-.338 0-.756-.13-1.082-.348-.343-.232-.418-.44-.418-.527M4.75 6a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0V12H7a3 3 0 1 0 0-6z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }